export const tasks = {
  en: {
    // ── Routed tasks — see docs/ROUTED-TASKS.md ─────────────────────────────
    kind: "Kind",
    routed: "Routed",
    newRoutedTask: "New routed task",
    routedTaskHelp: "A task that travels between people in sequence. Each person receives everything attached so far, adds their own notes and files, and hands it to the next.",
    routeTitle: "Route",
    routeOrderHelp: "In order. The first person starts with it. At least two people — for one, assign an ordinary task instead.",
    routeStopNumber: "Stop {n}",
    routePickPerson: "Choose a person…",
    routeAddStop: "Add a person",
    routePosition: "{position} of {total}",
    routeFinished: "Finished",
    routeEdit: "Change the route",
    routeReassign: "Give it to somebody else",
    routeReassignTo: "Hand this stop to",
    routeEditHelp: "You can change any stop the task has not reached yet. The {kept} it has already been through are part of the record and stay as they are.",
    routeStateDone: "Passed on",
    routeStateHolding: "Has it now",
    routeStateBlocked: "Blocked",
    routeStateWaiting: "Waiting",
    routeReceived: "received {at}",
    routePassedOn: "passed on {at}",
    routeOnLeave: "On leave today",
    routeHasLeft: "No longer employed",
    routeBlockedNotice: "The person holding this has left the company, so it has stopped where it is. Nothing has been moved or reassigned — change the route to say who picks it up.",
    passOn: "Pass it on",
    passOnFinish: "Pass on and finish",
    passOnNotYours: "Only the person currently holding this can pass it on.",
    routedNotTickable: "A routed task is finished by the last person passing it on. Open it to pass it on.",
    attachmentDownloadToOpen: "Download to open",
    attachmentPreview: "Preview",
    intervalOf_daily: "Repeat every … days",
    intervalOf_weekly: "Repeat every … weeks",
    intervalOf_monthly: "Repeat every … months",
    intervalOf_yearly: "Repeat every … years",
    startsOnRequired: "Required — this is the only thing that decides which day it lands on.",
    editTitle: "Edit task",
    removeTitle: "Delete this task?",
    removeNamed: "Delete “{title}”? This cannot be undone.",
    removeSeriesTitle: "Delete a repeating task",
    removeSeriesBody: "“{title}” repeats. Delete only this occurrence, or the whole series and every future one?",
    removeThisOne: "Only this one",
    removeWholeSeries: "The whole series",
    repeatsDue: "Repeats due this day",
    notYetCreated: "not created yet",
    projectedCount: "{count} repeat(s) due here, not created yet",
    removeBody: "The task and its notes will be permanently removed.",
    deleteRuleTitle: "Delete this repeating task?",
    deleteRuleBody: "The rule and any future occurrences will be removed. Completed and overdue occurrences are kept as a record and are not affected.",
    title: "Tasks",
    calendar: "Calendar",
    whatThisIs: "A reminder you set yourself, or work your manager assigns you. Both live here.",
    myTasks: "My tasks",
    newTask: "New task",
    newRecurring: "New repeating task",
    taskTitle: "Title",
    description: "Description",
    priority: "Priority",
    dueDate: "Due date",
    noDueDate: "No deadline",
    assignTo: "Assign to",
    myself: "Myself",
    personalTask: "Personal task",
    personalHint: "Only you can see a personal task. Your manager cannot.",
    priorityLow: "Low",
    priorityNormal: "Normal",
    priorityHigh: "High",
    priorityUrgent: "Urgent",
    statusOpen: "Open",
    statusOverdue: "Overdue",
    statusCompleted: "Completed",
    complete: "Mark complete",
    reopen: "Reopen",
    overdueCount: "{count} overdue",
    dueIn: "Due in {days} day(s)",
    overdueBy: "{days} day(s) overdue",
    dueToday: "Due today",
    monthView: "Month",
    weekView: "Week",
    dayView: "Day",
    today: "Today",
    previous: "Previous",
    next: "Next",
    tasksForDay: "Tasks for {date}",
    noTasksToday: "Nothing due on this day.",
    noTasks: "No tasks.",
    assigned: "Assigned",
    personal: "Personal",
    assignedBy: "Assigned by {name}",
    owner: "For",
    notes: "Notes",
    addNote: "Add a note",
    attachments: "Attachments",
    attachDocument: "Attach a document",
    selectDocumentPlaceholder: "Choose a document…",
    attach: "Attach",
    attachFile: "Attach a file (PDF, PNG or JPEG, max 10 MB)",
    detach: "Remove",
    showAllDocuments: "Show documents for all employees",
    noDocumentsToAttach: "No issued documents to attach.",
    history: "History",
    recurring: "Repeats",
    repeatsEvery: "Repeats",
    frequency: "Frequency",
    daily: "Daily",
    weekly: "Weekly",
    monthly: "Monthly",
    yearly: "Yearly",
    interval: "Every",
    startsOn: "Starts",
    endsOn: "Ends (optional)",
    stopRepeating: "Stop repeating",
    repeatingTasks: "Repeating tasks",
    tileDaysLeft: "{days} left",
    tileDueToday: "due today",
    tileOverdue: "{days} overdue",
    tileNextOn: "next on {date}",
    tileWasDue: "was due {date}",
    tileEnded: "series ended",
    tileActive: "Repeating",
    tileStopped: "Stopped",
    showCompleted: "Show completed",
    searchPlaceholder: "Search tasks",
    moreTasks: "and {count} more",
    onLeave: "You are on leave",
    payday: "Payday",
    teamOnLeaveCount: "{count} on leave",
    personOnLeave: "{name} is on leave",
    contractEventsCount: "{count} contract event(s)",
    contractExpiring: "{name}'s contract ends",
    probationEnding: "{name}'s probation ends",
  },
  ar: {
    // ── المهام المتسلسلة ────────────────────────────────────────────────────
    kind: "النوع",
    routed: "متسلسلة",
    newRoutedTask: "مهمة متسلسلة جديدة",
    routedTaskHelp: "مهمة تنتقل بين الأشخاص بالتتابع. يستلمها كل شخص بكل ما أُرفق بها حتى تلك اللحظة، يضيف ملاحظاته وملفاته، ثم يمررها إلى التالي.",
    routeTitle: "المسار",
    routeOrderHelp: "بالترتيب. يبدأ بها الشخص الأول. شخصان على الأقل — ولشخص واحد أسند مهمة عادية.",
    routeStopNumber: "المحطة {n}",
    routePickPerson: "اختر شخصاً…",
    routeAddStop: "إضافة شخص",
    routePosition: "{position} من {total}",
    routeFinished: "منتهية",
    routeEdit: "تعديل المسار",
    routeReassign: "تحويلها إلى شخص آخر",
    routeReassignTo: "تحويل هذه المحطة إلى",
    routeEditHelp: "يمكنك تغيير أي محطة لم تصلها المهمة بعد. أما المحطات الـ{kept} التي مرّت بها فهي جزء من السجل وتبقى كما هي.",
    routeStateDone: "مرّرها",
    routeStateHolding: "بحوزته الآن",
    routeStateBlocked: "متوقفة",
    routeStateWaiting: "بالانتظار",
    routeReceived: "استلمها {at}",
    routePassedOn: "مرّرها {at}",
    routeOnLeave: "في إجازة اليوم",
    routeHasLeft: "لم يعد على رأس العمل",
    routeBlockedNotice: "الشخص الذي بحوزته هذه المهمة لم يعد على رأس العمل، فتوقفت عند محطته. لم يتم نقلها أو إعادة إسنادها — عدّل المسار لتحديد من يستلمها.",
    passOn: "تمرير",
    passOnFinish: "تمرير وإنهاء",
    passOnNotYours: "لا يمكن تمرير المهمة إلا لمن هي بحوزته حالياً.",
    routedNotTickable: "تنتهي المهمة المتسلسلة عندما يمررها آخر شخص. افتحها لتمريرها.",
    attachmentDownloadToOpen: "نزّله لفتحه",
    attachmentPreview: "معاينة",
    intervalOf_daily: "التكرار كل … يوم",
    intervalOf_weekly: "التكرار كل … أسبوع",
    intervalOf_monthly: "التكرار كل … شهر",
    intervalOf_yearly: "التكرار كل … سنة",
    startsOnRequired: "مطلوب — هذا هو ما يحدد اليوم الذي تقع فيه كل مرة.",
    editTitle: "تعديل المهمة",
    removeTitle: "حذف هذه المهمة؟",
    removeNamed: "حذف «{title}»؟ لا يمكن التراجع عن هذا.",
    removeSeriesTitle: "حذف مهمة متكررة",
    removeSeriesBody: "«{title}» مهمة متكررة. هل تحذف هذا التكرار فقط، أم السلسلة كاملة وكل تكراراتها القادمة؟",
    removeThisOne: "هذا التكرار فقط",
    removeWholeSeries: "السلسلة كاملة",
    repeatsDue: "تكرارات تستحق في هذا اليوم",
    notYetCreated: "لم تُنشأ بعد",
    projectedCount: "{count} تكرار يستحق هنا، لم يُنشأ بعد",
    removeBody: "سيتم حذف المهمة وملاحظاتها نهائياً.",
    deleteRuleTitle: "حذف هذه المهمة المتكررة؟",
    deleteRuleBody: "سيتم حذف القاعدة وأي تكرارات مستقبلية معها. أما التكرارات المكتملة أو المتأخرة فتبقى كسجل ولا تتأثر.",
    title: "المهام",
    calendar: "التقويم",
    whatThisIs: "تذكير تضعه لنفسك، أو عمل يُسنده إليك مديرك. كلاهما هنا.",
    myTasks: "مهامي",
    newTask: "مهمة جديدة",
    newRecurring: "مهمة متكررة",
    taskTitle: "العنوان",
    description: "الوصف",
    priority: "الأولوية",
    dueDate: "تاريخ الاستحقاق",
    noDueDate: "بدون موعد",
    assignTo: "إسناد إلى",
    myself: "نفسي",
    personalTask: "مهمة شخصية",
    personalHint: "المهمة الشخصية تظهر لك وحدك، ولا يراها مديرك.",
    priorityLow: "منخفضة",
    priorityNormal: "عادية",
    priorityHigh: "مرتفعة",
    priorityUrgent: "عاجلة",
    statusOpen: "مفتوحة",
    statusOverdue: "متأخرة",
    statusCompleted: "مكتملة",
    complete: "تعليم كمكتملة",
    reopen: "إعادة الفتح",
    overdueCount: "{count} متأخرة",
    dueIn: "تستحق خلال {days} يوم",
    overdueBy: "متأخرة {days} يوم",
    dueToday: "تستحق اليوم",
    monthView: "شهر",
    weekView: "أسبوع",
    dayView: "يوم",
    today: "اليوم",
    previous: "السابق",
    next: "التالي",
    tasksForDay: "مهام يوم {date}",
    noTasksToday: "لا توجد مهام في هذا اليوم.",
    noTasks: "لا توجد مهام.",
    assigned: "مُسندة",
    personal: "شخصية",
    assignedBy: "أسندها {name}",
    owner: "لـ",
    notes: "الملاحظات",
    addNote: "إضافة ملاحظة",
    attachments: "المرفقات",
    attachDocument: "إرفاق مستند",
    selectDocumentPlaceholder: "اختر مستنداً…",
    attach: "إرفاق",
    attachFile: "إرفاق ملف (PDF أو PNG أو JPEG، بحد أقصى 10 ميجابايت)",
    detach: "إزالة",
    showAllDocuments: "عرض مستندات كل الموظفين",
    noDocumentsToAttach: "لا توجد مستندات صادرة لإرفاقها.",
    history: "السجل",
    recurring: "متكررة",
    repeatsEvery: "التكرار",
    frequency: "التكرار",
    daily: "يومياً",
    weekly: "أسبوعياً",
    monthly: "شهرياً",
    yearly: "سنوياً",
    interval: "كل",
    startsOn: "تبدأ",
    endsOn: "تنتهي (اختياري)",
    stopRepeating: "إيقاف التكرار",
    repeatingTasks: "المهام المتكررة",
    tileDaysLeft: "تبقى {days}",
    tileDueToday: "تستحق اليوم",
    tileOverdue: "تأخرت {days}",
    tileNextOn: "القادمة {date}",
    tileWasDue: "استحقت {date}",
    tileEnded: "انتهت السلسلة",
    tileActive: "متكررة",
    tileStopped: "موقوفة",
    showCompleted: "عرض المكتملة",
    searchPlaceholder: "ابحث في المهام",
    moreTasks: "و {count} أخرى",
    onLeave: "أنت في إجازة",
    payday: "يوم صرف الرواتب",
    teamOnLeaveCount: "{count} في إجازة",
    personOnLeave: "{name} في إجازة",
    contractEventsCount: "{count} حدث عقد",
    contractExpiring: "ينتهي عقد {name}",
    probationEnding: "تنتهي فترة تجربة {name}",
  },
} as const;
